// extracted by mini-css-extract-plugin
export default {"bloc":"S9laP","title":"ULBBg"};